import { KeyValue } from "@/main/models/common";
import { SupplierTypeTypes, SupplierTypeActionTypes } from "./supplierTypeTypes";

export function getSupplierType(): SupplierTypeActionTypes {
	return {
		type: SupplierTypeTypes.GET_SUPPLIER_TYPE,
	};
}

export function saveSupplierType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): SupplierTypeActionTypes {
	return {
		type: SupplierTypeTypes.SAVE_SUPPLIER_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerSuppliersType(): SupplierTypeActionTypes {
	return {
		type: SupplierTypeTypes.RESET_REDUCER_SUPPLIER_TYPE,
	};
}
